// if: lines of code > 300
// then: breakdown this file and move to src/features/PricingSection/utils folder

import constants from "constants/constants";
import {
  MIN_GST_PERCENTAGE,
  MIN_SUBS_DAYS_DURATION_VALUE,
  MIN_SUBS_DURATION_VALUE,
} from "./PricingSection.constants";
import { no_schedule_course_end_choices_values } from "features/Listings/Listings.constants";

export const getGstPercentage = (metadata) => {
  return metadata?.service_gst_percent >= MIN_GST_PERCENTAGE
    ? metadata?.service_gst_percent
    : constants.GST_PERCENTAGE;
};

export const isAutoDebitEnabledOnDaysChoice = (values) => {
  return (
    values?.subscription_config?.is_auto_debit_active &&
    isDaysSubscriptionUnitSelected(values)
  );
};

export const isDaysSubscriptionUnitSelected = (values) => {
  return (
    values?.subscription_config?.subscription_unit ===
    no_schedule_course_end_choices_values.days
  );
};

export const deleteSubscriptionDuration = ({ updated_values, values }) => {
  const subsDuration = values?.subscription_config?.subscription_duration;

  if (
    (isAutoDebitEnabledOnDaysChoice(values) &&
      subsDuration < MIN_SUBS_DAYS_DURATION_VALUE) ||
    subsDuration < MIN_SUBS_DURATION_VALUE
  ) {
    // this key might be present in form at this step due to switching between step in live offering
    // and we don't have to parse or save subscription if the validation fails
    // check usage of processUnlockingBasedOnInstallments function for reference
    delete updated_values?.subscription_config?.subscription_duration;
  }

  if (
    isAutoDebitEnabledOnDaysChoice(values) &&
    subsDuration < MIN_SUBS_DAYS_DURATION_VALUE
  ) {
    // this key might be present in form at this step due to switching between step in live offering
    // and we don't have to parse or save subscription_config.is_auto_debit as true if subsDuration is less
    // check usage of processUnlockingBasedOnInstallments function for reference
    updated_values = {
      ...updated_values,
      subscription_config: {
        ...updated_values?.subscription_config,
        is_auto_debit_active: false,
      },
    };
  }

  return updated_values;
};

/**
 * Reverts the international pricing in the updated values object if auto debit is active and the international price is not updated.
 * @param {Object} options - Options object containing updated values, initial data, and current values.
 * @param {Object} options.updated_values - The updated values object.
 * @param {Object} options.initialData - The initial data object.
 * @param {Object} options.values - The current values object.
 * @returns {Object} - The updated values object with reverted international pricing if applicable.
 */
export const revertPricingInternational = ({
  updated_values,
  initialData,
  values,
}) => {
  if (
    values.subscription_config?.is_auto_debit_active &&
    !updated_values.price_international &&
    values.is_international_price_allowed
  ) {
    //need to set price_internation to initial value if auto debit is enabled & price is removed & user tries to navigate accros pages using stepper.
    updated_values.price_international = initialData.price_international;
  }
  return updated_values;
};
